import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import classNames from 'classnames';

import { RandomId } from '../../../Functions/RandomId';

import styles from './FormInput.module.scss';

export interface FormInputPropsI {
  label: string;
  type: 'text' | 'number' | 'password' | 'email' | 'tel';
  placeholder?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSelect?: () => void;
  validationError?: string;
  icon: string;
  margin?: string;
  readonly?: boolean;
  maxLength?: number;
  minLength?: number;
  defaultValue?: string;
  width?: string;
}

const FormInput: React.FC<FormInputPropsI> = ({
  label,
  type,
  placeholder,
  value,
  onChange,
  validationError,
  onSelect,
  icon,
  margin,
  readonly,
  maxLength,
  minLength,
  defaultValue,
  width
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const id = RandomId();
  return (
    <div className={styles.FormInput} style={{ margin: margin, width: width }}>
      <label className={styles.FormInput__label} htmlFor={id}>
        {label}
      </label>
      <div
        className={classNames(styles.FormInput__input_container, {
          [styles.FormInput__input_container_error]: validationError,
          [styles.FormInput__input_container_readonly]: readonly
        })}
      >
        <img src={icon} alt="" className={styles.FormInput__icon} />

        <input
          type={type === 'password' && isPasswordVisible ? 'string' : type}
          autoComplete={type === 'password' ? 'on' : undefined}
          className={classNames(styles.FormInput__input, {
            [styles.FormInput__input_noicon]: icon === '',
            [styles.FormInput__input_readOnly]: readonly
          })}
          {...{
            maxLength,
            minLength,
            readOnly: readonly,
            onChange,
            onSelect,
            placeholder,
            value,
            id,
            defaultValue
          }}
        />
        {type === 'password' && (
          <div className={styles.FormInput__icon_container}>
            {isPasswordVisible && (
              <AiOutlineEyeInvisible
                className={styles.FormInput__icon_eye}
                onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                size={16}
              />
            )}
            {!isPasswordVisible && (
              <AiOutlineEye
                className={styles.FormInput__icon_eye}
                onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                size={16}
              />
            )}
          </div>
        )}
      </div>
      {validationError ? (
        <span className={styles.FormInput__error_message}>{validationError}</span>
      ) : null}
    </div>
  );
};

export type FormInputType = typeof FormInput;

export default FormInput;
